import { DATA_ENTERPRISE_DEMO_IEAM_1 } from "./EnterpriseDemo/111EnterpriseDemoIEAM1";
import { DATA_ENTERPRISE_DEMO_IEAM_2 } from "./EnterpriseDemo/112EnterpriseDemoIEAM2";
import { DATA_ENTERPRISE_DEMO_IEAM_3 } from "./EnterpriseDemo/113EnterpriseDemoIEAM3";
import { DATA_ENTERPRISE_DEMO_IEAM_4 } from "./EnterpriseDemo/114EnterpriseDemoIEAM4";
import { DATA_ENTERPRISE_DEMO_IEAM_END } from "./EnterpriseDemo/115EnterpriseDemoIEAMEnd";
import { DATA_GEN_AI_DEMO_IEAM_1 } from "./GenAiDemo/116GenAiDemoIEAM1";
import { DATA_GEN_AI_DEMO_IEAM_2 } from "./GenAiDemo/117GenAiDemoIEAM2";
import { DATA_GEN_AI_DEMO_IEAM_3 } from "./GenAiDemo/118GenAiDemoIEAM3";
import { DATA_GEN_AI_DEMO_IEAM_4 } from "./GenAiDemo/119GenAiDemoIEAM4";
import { DATA_GEN_AI_DEMO_IEAM_5 } from "./GenAiDemo/120GenAiDemoIEAM5";
import { DATA_GEN_AI_DEMO_IEAM_END } from "./GenAiDemo/121GenAiDemoIEAMEnd";
import { DATA_INTRO_IEAM } from "./Introduction/101DataIntroIEAM";
import { DATA_BENEFITS_IEAM_1 } from "./Introduction/102DataBenefitsIEAM";
import { DATA_BENEFITS_IEAM_2 } from "./Introduction/103DataBenefitsIEAM";
import { DATA_CHARACTERS_IEAM } from "./Introduction/104DataCharactersIEAM";
import { DATA_PROVIDER_DEMO_IEAM_1 } from "./ProviderDemo/105ProviderDemoIEAM1";
import { DATA_PROVIDER_DEMO_IEAM_2 } from "./ProviderDemo/106ProviderDemoIEAM2";
import { DATA_PROVIDER_DEMO_IEAM_3 } from "./ProviderDemo/107ProviderDemoIEAM3";
import { DATA_PROVIDER_DEMO_IEAM_4 } from "./ProviderDemo/108ProviderDemoIEAM4";
import { DATA_PROVIDER_DEMO_IEAM_5 } from "./ProviderDemo/109ProviderDemoIEAM5";
import { DATA_PROVIDER_DEMO_IEAM_END } from "./ProviderDemo/110ProviderDemoIEAMEnd";

export const IEAM_WORKFLOW = [
  { page: "ENG_101", type: "intro-template" as TemplateType, data: DATA_INTRO_IEAM },
  {
    page: "ENG_102",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_IEAM_1,
  },
  {
    page: "ENG_103",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_IEAM_2,
  },
  {
    page: "ENG_104",
    type: "characters-template" as TemplateType,
    data: DATA_CHARACTERS_IEAM,
  },
  {
    page: "ENG_105",
    type: "journey-one-template" as TemplateType,
    data: DATA_PROVIDER_DEMO_IEAM_1,
  },
  {
    page: "ENG_106",
    type: "journey-one-template" as TemplateType,
    data: DATA_PROVIDER_DEMO_IEAM_2,
  },
  {
    page: "ENG_107",
    type: "journey-one-template" as TemplateType,
    data: DATA_PROVIDER_DEMO_IEAM_3,
  },
  {
    page: "ENG_108",
    type: "journey-one-template" as TemplateType,
    data: DATA_PROVIDER_DEMO_IEAM_4,
  },
  {
    page: "ENG_109",
    type: "journey-one-template" as TemplateType,
    data: DATA_PROVIDER_DEMO_IEAM_5,
  },
  {
    page: "ENG_110",
    type: "end-template" as TemplateType,
    data: DATA_PROVIDER_DEMO_IEAM_END,
  },
  {
    page: "ENG_111",
    type: "journey-one-template" as TemplateType,
    data: DATA_ENTERPRISE_DEMO_IEAM_1,
  },
  {
    page: "ENG_112",
    type: "journey-one-template" as TemplateType,
    data: DATA_ENTERPRISE_DEMO_IEAM_2,
  },
  {
    page: "ENG_113",
    type: "journey-one-template" as TemplateType,
    data: DATA_ENTERPRISE_DEMO_IEAM_3,
  },
  {
    page: "ENG_114",
    type: "journey-one-template" as TemplateType,
    data: DATA_ENTERPRISE_DEMO_IEAM_4,
  },
  {
    page: "ENG_115",
    type: "end-template" as TemplateType,
    data: DATA_ENTERPRISE_DEMO_IEAM_END,
  },
  {
    page: "ENG_116",
    type: "journey-two-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_IEAM_1,
  },
  {
    page: "ENG_117",
    type: "journey-two-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_IEAM_2,
  },
  {
    page: "ENG_118",
    type: "journey-two-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_IEAM_3,
  },
  {
    page: "ENG_119",
    type: "journey-two-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_IEAM_4,
  },
  {
    page: "ENG_120",
    type: "journey-two-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_IEAM_5,
  },
  {
    page: "ENG_121",
    type: "end-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_IEAM_END,
  },
];
